import React from 'react';
import Layout from '../components/Layout';
import YourCommunities from '../UI-Components/YourCommunities/YourCommunities';
import '../css/CommunityPage.css';
import NewCommunities from '../UI-Components/NewCommunities/NewCommunities';
import WhyCommunity from '../UI-Components/WhyCommunity/WhyCommunity';

const CommunityPage = () => {
  return (
    <Layout pageTitle="My Community &#x1F468;&#x200D;&#x1F468;&#x200D;&#x1F466;" style={{ backgroundColor: '#FFFFFF' }}>
      <YourCommunities />
      <div className="rounded-componentHome rounded-component-margin" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <div className="content-container">
          <div className="welcome-container">
            <span className='welcome-line1'>Welcome to The</span>
            <br />
            <span className='welcome-line2'>JoyNet Communities &#128075;</span>
          </div>
          <div className="welcome-subline-container">
            <span className='welcome-subline1'>Welcome to Your Circle of Support - Discover groups that</span>
            <br />
            <span className='welcome-subline2'>resonate with your heart. In 'My Community', find your</span>
            <br />
            <span className='welcome-subline2'>place to belong, share, and grow</span>
          </div>
        </div>
      </div>
      <NewCommunities />
      <WhyCommunity />
    </Layout>
  );
};

export default CommunityPage;
